import { useMemo } from 'react';

import {
  buildLevelLabelsByDepth,
  type DepthToLabelMap,
} from '../utils/taxonomyTree';
import { useActivityTaxonomyTree } from './useActivityTaxonomyTree';

export const useActivityLevelLabels = ({
  enabled = true,
  taxonomyId,
  taxonomyVersion,
}: {
  enabled?: boolean;
  taxonomyId?: number;
  taxonomyVersion?: string;
} = {}) => {
  const { levels } = useActivityTaxonomyTree({
    enabled,
    overrideTaxonomyId: taxonomyId,
    taxonomyVersionOverride: taxonomyVersion,
  });

  const labelsByDepth: DepthToLabelMap | null = useMemo(
    () => buildLevelLabelsByDepth(levels),
    [levels]
  );

  return { labelsByDepth };
};
